<main>
  @if (loadingHttpReq || loadingRouterReq) {
    <mat-progress-bar data-testid="progress_bar" [color]="loadingHttpReq ? 'accent': loadingRouterReq ? 'warn' : 'indeterminate'" mode="indeterminate"></mat-progress-bar>
  }
  <app-sidenav class="layout" >
    <div class="container">
      <div class="header">
        <xng-breadcrumb data-testid="breadcrumb" [separator]="iconTemplate">
          <ng-container 
            *xngBreadcrumbItem="let breadcrumb; let info = info; let first = first">
            @if (info) {
              <img data-testid="home_link" src="../assets/icons/home.svg">
            }
            @if (!first) {
              <span [attr.data-testid]="breadcrumb" >
                {{ "BREADCRUMB." + breadcrumb.replaceAll("-", "_") | uppercase | translate}}
              </span>
            }
          </ng-container>
        </xng-breadcrumb>
        <ng-template #iconTemplate>
          <mat-icon>arrow_right</mat-icon>
        </ng-template>
      </div>
      <router-outlet></router-outlet>
    </div>
  </app-sidenav>
</main>
